export const modules = (state) => state.session.modules
export const user = (state) => state.session.user
